//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../no/BasePart.js";
let d=[[[0,"CoordinateSystem",0,"CartesianCoordinateSystem",0],[0,"Origin",1,0],[0,"Visibility",1,0]],[[[],"Save",{R_:{cs:"CartesianCoordinateSystem"}},0,0],[["origin","matrix"],"SetOriginAndMatrix",{},2,0],[["rotation_axis","angle"],"Rotate",{},2,0],[["new_cs"],"SetCoordinateSystem",{R_:{old_cs:"CartesianCoordinateSystem"}},1,0],[["new_cs"],"SetCoordinateSystemCartesianAtCsys",{R_:{old_cs:"CartesianCoordinateSystem"}},1,0]],[]];
SPLM.WCS = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.WCS";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.WCS.Axis = Object.freeze({
    "XAxis" : "XAxis", "YAxis" : "YAxis", "ZAxis" : "ZAxis"});

export default SPLM;